import styled from '@emotion/styled';
import { theme } from '@pairy/styles';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const Track = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${VIEWER_Z_INDEX.desktopLayer};
  width: 100%;
  height: 3px;
  background: ${theme.colors.zinc_200};
`;

export const Fill = styled.div`
  height: 100%;
  background: ${theme.colors.skyblue_400};
  transition: width 0.15s ease-in-out;
`;
